export default __webpack_public_path__ + "static/media/classroom.7313b195.jpg";